import * as yup from "yup";

export const MAP_REQUESTOR_FIELD_MAPPING = {
  id: "MapRequestTypeID",
  name: "MapRequestorName",
  description: "MapRequestorDesc",
  timestamp: "LastModified",
  deleteIdsKey: "MapRequestorIds",
  nameLabel: "Map Requestor",
  descriptionLabel: "Map Requestor Description",
  timestampLabel: "Last Modified",
};

export const DEFAULT_FIELD_MAPPING = {
  id: "AgencyID",
  name: "AgencyName",
  description: "AgencyDescription",
  timestamp: "LastModified",
  deleteIdsKey: "AgencyIds",       
  nameLabel: "Agency Name",
  descriptionLabel: "Agency Description",
  timestampLabel: "Last Modified Timestamp",
};

export const CREATE_DEFAULT_FIELD_MAPPING = {
  id: "AgencyID",
  name: "AgencyName",
  description: "AgencyDescription",
  nameLabel: "Agency Name",
  descriptionLabel: "Agency Description",
};

export const createAgencySchema = (fieldMapping, options = {}) => {
  const { nameMaxLength = 100, descriptionMaxLength = 255 } = options;

  return yup.object().shape({
    [fieldMapping.name]: yup
      .string()
      .required(`${fieldMapping.nameLabel} is required`)
      .max(nameMaxLength, `${fieldMapping.nameLabel} must be at most ${nameMaxLength} characters`),
    [fieldMapping.description]: yup
      .string()
      .required(`${fieldMapping.descriptionLabel} is required`)
      .max(descriptionMaxLength, `${fieldMapping.descriptionLabel} must be at most ${descriptionMaxLength} characters`),
  });
};

export const PIPELINE_FIELD_MAPPING = {
  id: "PipelineID",
  name: "PipelineName",
  description: "PipelineDescription",
  isActive: "IsActive",
  isConsumptionVisible: "IsConsumptionVisible",
  isStorageVisible: "IsStorageVisible",
  timestamp: "LastModified",
  deleteIdsKey: "PipelineIds",
  nameLabel: "Pipeline Name",
  descriptionLabel: "Pipeline Description",
  isActiveLabel: "Active",
  isConsumptionVisibleLabel: "Consumption Visible",
  isStorageVisibleLabel: "Storage Visible",
  timestampLabel: "Last Modified Timestamp",
};

export const createPipelineSchema = (fieldMapping = PIPELINE_FIELD_MAPPING) =>
  createAgencySchema(fieldMapping).shape({
    [fieldMapping.isActive]: yup.boolean(),
    [fieldMapping.isConsumptionVisible]: yup.boolean(),
    [fieldMapping.isStorageVisible]: yup.boolean(),
  });
